import React from "react";

import { observer } from "mobx-react";

import { store } from "./FavoritesMenuItems";

import { FavoritesMenuItemList } from ".";

export const FavoritesMenuItem = observer(function FavoritesMenuItem(props: {
	store: store;
}) {
	return (
		<>
			{[
				{ type: "tournaments", name: "FAVORITES.TOURNAMENTS" },
				{ type: "events", name: "LIVE.LIVE_SUB_MENU.EVENTS" },
			].map((period) => (
				<FavoritesMenuItemList
					key={period.type}
					type={period.type}
					name={period.name}
					store={props.store}
				/>
			))}
		</>
	);
});
